<template>
  <div v-if="isLogin && !hasMaintenance" class="relative">
    <button
      ref="buttonRef"
      class="flex h-10 w-10 items-center justify-center"
      :title="userName"
      @click="handleClick"
    >
      <div
        class="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-solid border-blue-200 bg-blue-100"
      >
        <span
          class="flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold text-blue-400"
        >
          {{ userNameAbbrev }}
        </span>
      </div>
      <LayoutHeaderMemberIcon
        v-if="profile.hasMultipleAccounts"
        class="-ml-2 h-8 w-8"
      />
    </button>

    <div
      v-if="isShowProfile"
      ref="profileRef"
      class="absolute right-0 top-11 z-10"
    >
      <LayoutHeaderAccountProfile />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onClickOutside } from '@vueuse/core';

  const profileStore = useProfileStore();
  const { isLogin, profile, userName, userNameAbbrev } =
    storeToRefs(profileStore);

  const buttonRef = ref<HTMLElement | null>(null);
  const profileRef = ref<HTMLElement | null>(null);
  const isShowProfile = ref<boolean>(false);

  const hasMaintenance = computed((): boolean => {
    /**
     * * NOTE: 目前是否有開啟維護公告
     * * 如果有開啟維護公告，則不顯示登入按鈕（未登入）與會員按鈕（已登入）
     */
    return !!profile.value.maintenanceTimePeriod;
  });

  const handleClick = (): void => {
    isShowProfile.value = !isShowProfile.value;
  };

  onClickOutside(
    profileRef,
    () => {
      isShowProfile.value = false;
    },
    {
      ignore: [buttonRef],
    }
  );
</script>
